<template>
  <div class="courier-delivery-page ug-trans-courier-delivery-page">
    <div class="banner-wrapper">
      <div class="banner">
        <header-menu style="position: relative" />
        <div class="banner-body">
          <div>
            <div class="banner-body-title">
              <span class="banner-body-title-pill">ЮГТранс ТЭК</span>
              <strong>Курьерская доставка</strong>
            </div>
            <div class="banner-body-description">
              <p>Отправляйте и получайте так, как удобно</p>
              <p>Передайте отправление курьеру или самостоятельно привезите его на терминал ЮГТранс ТЭК.</p>
              <p>Получатель сможет забрать отправление на терминале ЮГТранс ТЭК, в ПВЗ Яндекса или заказать доставку по адресу.</p>
            </div>

            <div class="banner-body-data">
              <div
                v-for="item in featureItems"
                :key="item.title"
              >
                <img :src="item.icon">
                <div>{{ item.title }}</div>
                <span>{{ item.description }}</span>
              </div>
            </div>
          </div>
          <t-calculator
            id="courier-delivery-calculator"
            ref="calculator"
            class="calculator"
            is-courier-delivery
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue'
import TCalculator from '@/components/TCalculator.vue'
import HeaderMenu from '@/components/HeaderMenu.vue'

const featureItems = [
  {
    icon: require('@/assets/icons/check.svg'),
    title: 'Курьер или терминал',
    description: 'Передайте отправление удобным способом'
  },
  {
    icon: require('@/assets/icons/point.svg'),
    title: 'До двери, терминала или ПВЗ',
    description: 'Получатель сам выбирает удобный вариант'
  },
  {
    icon: require('@/assets/icons/search-check.svg'),
    title: 'Отслеживание на всём пути',
    description: 'Статус отправления доступен онлайн'
  }
]

export default {
  name: 'UgTransCourierDeliveryBanner',
  components: {
    HeaderMenu,
    TCalculator
  },
  setup(_, {expose}) {
    const calculator = ref(null)

    function setDirection(item) {
      calculator.value?.setDirection(item)
    }

    expose({
      setDirection
    })

    return {
      calculator,
      featureItems
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/banner.css";

$pub-md: 1239px;

.courier-delivery-page {
  font-family: 'Roboto', sans-serif;

  :deep(.calculator) {
    width: 420px;
    max-width: 100%;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  :deep(.calculator) h2 {
    font-size: 26px;
    line-height: 36px;
    text-transform: uppercase;
  }

  :deep(.menu-wrapper-header-title) {
    color: white;
  }

  .banner-body-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;

    &-pill {
      font-size: 26px;
      line-height: 1;
      color: white;
      background-color: var(--primary-color);
      display: inline-block;
      padding: 5px 15px 7px 10px;
      border-radius: 12px;
      font-family: 'Open Sans', sans-serif;
    }

    :deep(strong) {
      font-size: 52px;
      line-height: 100%;
      font-weight: 600;
      padding-bottom: 0;
      font-family: 'Open Sans', sans-serif;
      color: white;
    }

    :deep(strong::after) {
      display: none;
    }
  }
}

.banner-wrapper {
  position: relative;
  background-image: url("../../assets/images/ugtrans_banner.jpg");
  background-size: cover;
  background-position: center;

  * {
    z-index: 1;
  }

  .banner-body {
    color: white;
    margin-bottom: unset;
  }
}

.banner-body-title {
  margin-top: 80px;
  line-height: 48px;
}

.banner-body-description {
  width: 100%;
  max-width: unset;

  p {
    &:first-child {
      font-size: 22px;
      font-weight: 500;
      margin: 20px 0 0 0;
      line-height: 42px;
    }

    &:not(:first-child) {
      font-size: 18px;
      font-weight: 400;
      margin: 5px 0 0 0;
      line-height: 26px;
    }
  }
}

.banner {
  max-width: 1240px;
  width: 97%;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 40px;
}

.banner-body-data {
  width: 100%;
  max-width: none;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 40px;
}

@media screen and (max-width: $pub-md - 1) {
  .banner-body {
    flex-direction: column;
    margin-top: 60px;
    gap: 55px;

    &-title {
      margin-top: 0;
    }
  }

  .courier-delivery-page {
    :deep(.calculator) {
      width: 100%;
    }
  }
}

@media screen and (max-width: 768px) {
  .banner-body {
    flex-direction: column;
    margin-top: 40px;
  }
}

@media screen and (max-width: 420px) {
  .banner {
    padding-bottom: unset;
    margin-bottom: 600px;
  }

  .courier-delivery-page {
    :deep(.calculator) {
      margin-bottom: -500px;
    }
  }

  .banner-body-data {
    grid-template-columns: 1fr;
  }
}
</style>
